export const FETCH_TAB_CELLS = 'fetchTabCells';
export const UPDATE_ACTIVE_SORT_FIELD_TAB_CELLS = 'updateActiveSortFieldTabCells';
export const UPDATE_SEARCH_TAB_CELLS = 'updateSearchTabCells';
export const CLEAR_SEARCH_TAB_CELLS = 'clearSearchTabCells';
